import React, { Component } from "react";

import queryString from "query-string";
import { Button, Card, CardBody, Container } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import CohortReportsSettingPanel from "./components/CohortReportsSettingPanel";
import styled from "styled-components";
import Select from "react-select";
import DynamicFormMultipleFilter from "../../../components/forms/DynamicFormMultipleFilter";
import CohortReportsChartView from "./components/CohortReportsChartView";
import CohortReportsTableView from "./components/CohortReportsTableView";
import PropTypes from "prop-types";
import {
  changeCohortReportTemplate,
  downloadCohortReportData,
  initCohortReport,
  getCohortReportList,
  getCohortReportOptions,
  getCohortReportParamsForFragmentation,
  patchCohortReportCohortSetup,
  setCohortReportCohortSetup,
  setCohortReportShowFilter,
  saveCohortReportTemplate,
  createCohortReportTemplate,
  deleteCohortReportTemplate,
  setInitCohortReportState,
} from "../../../store/cohort-reports/actions";
import CSelect from "../../../components/CSelect";
import ReportingTemplates from "./components/ReportingTemplates";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

window.qs = queryString;

export const DATE_OPTIONS = [
  { label: "30 Days", value: 30 },
  { label: "60 Days", value: 60 },
  { label: "90 Days", value: 90 },
];

export const COHORT_TYPE_OPTIONS = [
  { label: "User acquisition", value: "user-acquisition" },
  { label: "Retargeting", value: "retargeting", disabled: true },
  { label: "Unified", value: "unified", disabled: true },
];

export const TREND_TYPE_OPTIONS = [
  {
    label: "User lifetime performance",
    value: "user-lifetime-performance",
    default: true,
  },
  {
    label: "KPI by attribution time",
    value: "kpi-by-attribution",
    disabled: true,
  },
];

const TYPE_OF_VIEW_OPTIONS = [
  {
    label: "Chart",
    value: "chart",
    icon: "mdi mdi-chart-bar",
    disabled: true,
  },
  {
    label: "Table",
    value: "table",
    icon: "bx bx-table",
  },
];

export const EVENT_OPTIONS = [
  { label: "Count", value: "/event_count/" },
  { label: "Revenue", value: "/event_revenue/" },
  { label: "Unique users", value: "/event_unique_users/" },
  { label: "In App Conversion", value: "/event_in_app_conversion/" },
];

export const DATA_FORMAT_OPTIONS = [
  {
    label: "Cumulative",
    value: "cumulative",
    icon: "mdi mdi-chart-bell-curve-cumulative",
    // disabled: true
  },
  {
    label: "On day",
    value: "on_day",
    icon: "mdi mdi-chart-line",
    // disabled: true
  },
];

export const TEMPLATE_KEYS = ["days", "group_by", "filter_by", "show", "type"];

class CohortReports extends Component {
  state = {
    type_of_view: TYPE_OF_VIEW_OPTIONS[1].value,
    // data_format: DATA_FORMAT_OPTIONS[1].value,
  };

  getParsedQuery = () => {
    const parsed = queryString.parse(window.location.search, {
      arrayFormat: "bracket",
    });
    Object.keys(parsed).forEach(key => {
      const item = parsed[key];
      switch (key) {
        case "days":
          parsed.days = DATE_OPTIONS.find(
            i => i.value.toString() === item.toString()
          );
          break;
        default:
          break;
      }
    });
    return parsed;
  };

  getParsedData = () => {
    const { app_id } = this.props.match.params;
    return {
      ...this.props.cohort_setup,
      app_id,
    };
  };

  componentDidMount() {
    const data = this.getParsedData();
    const parsed = this.getParsedQuery();
    // console.log(data)
    // this.props.getCohortReportList()
    this.props.initCohortReport(data, parsed);
  }

  onChangeTypeOfView = value => this.setState({ type_of_view: value });

  onFiltersChange = filter => {
    const { start_date, end_date } = filter;
    this.props.patchCohortReportCohortSetup(
      { start_date, end_date },
      this.handleUpdateQuery
    );
  };

  onFilterSelect = (data, item) => {
    console.log({ data, item });
  };

  handleUpdateQuery = () => {
    const data = {
      ...this.props.cohort_setup,
      ...this.props.show_filter,
    };
    const params = {};

    const DELIMITER = "|$|";

    Object.keys(data).forEach(key => {
      const item = data[key];

      switch (key) {
        case "start_date":
        case "end_date":
          if (!item) return void 0;
          params[key] = item;
          break;
        // case "group_by":
        //   params.group_by = item.map(i => i.value)
        //   break
        // case "filter_by":
        //   params.filter_by = item.map(i => `${i.value.value}${DELIMITER}${i.sub_value.map(v => v.value).join(DELIMITER)}`)
        //   break
        // case "days":
        //   if (item.value !== DATE_OPTIONS[0].value) {
        //     params.days = item.value
        //   }
        //   break
        // case "v2th":
        //
        //   if (!Array.isArray(data.v1th)) { // params options in show
        //     params.show = item.value
        //     break
        //   } else {
        //     params.show = `${item.value}?events=${data.v1th.map(i => i.value).join(',')}`
        //   }
        //   break;
        // case "type":
        //   if (item !== DATA_FORMAT_OPTIONS[0].value) {
        //     params.type = item
        //   }
        //   break;
        default:
          break;
      }
    });
    const str = queryString.stringify(params, {
      arrayFormat: "bracket",
      skipEmptyString: true,
    });

    // const parsed = queryString.parse(str, {arrayFormat: 'bracket'})
    window.history.replaceState(
      null,
      "",
      `/quality-cohort-report/${data.app_id}?${str}`
    ); // change match param app_id (without reload)
  };

  onChangeCohortSetup = data => {
    this.props.patchCohortReportCohortSetup(data, () => {
      this.handleUpdateQuery();
    });
  };

  /**
   * @param {number} which number of select (1 or 2)
   * @param {object} value selected value
   * */
  onChangeShowFilter = (which, value) => {
    if (which === 1) {
      const type_of_options = Array.isArray(value) ? "events" : "params";
      const options =
        type_of_options === "params"
          ? this.props.options[type_of_options].find(
              i => i.value.value === value.value
            ).options
          : EVENT_OPTIONS;
      this.props.setCohortReportShowFilter({
        v1th: value,
        v2th: options[0],
        o2th: options,
      });
    } else {
      this.props.setCohortReportShowFilter({
        v2th: value,
      });
    }
    this.props.patchCohortReportCohortSetup({}, this.handleUpdateQuery);
  };

  onChangeDays = v => {
    this.props.patchCohortReportCohortSetup(
      { days: v },
      this.handleUpdateQuery
    );
  };

  onChangeType = type => {
    this.props.patchCohortReportCohortSetup({ type }, this.handleUpdateQuery);
  };

  getLabelByValue = (value, options = []) => {
    return options.find(i => i.value === value)?.label;
  };

  componentWillUnmount() {
    this.props.setInitCohortReportState();
  }

  handleExport = () => {
    const { data, cohort_setup, show_filter } = this.props;

    const keys = [...cohort_setup.group_by.map(i => i.value), "users"];

    const header = [
      ...cohort_setup.group_by.map(i => i.label),
      "Users",
      ...new Array(cohort_setup.days.value)
        .fill(0)
        .map(
          (_, idx) =>
            `${show_filter.v1th.label} - ${show_filter.v2th.label} - day ${idx}`
        ),
    ].join(",");

    let rez = header + "\n";

    data.forEach(i => {
      const val = [];
      keys.forEach(key => {
        val.push(i[key]);
      });
      i.days.forEach(day => {
        val.push(day);
      });
      rez += val.join(",") + "\n";
    });

    const blob = new Blob([rez], { type: "text/csv;charset=utf-8;" });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `cohort_report_${cohort_setup.app_id}.csv`);
    link.click();
  };

  render() {
    const {
      data,
      loading,
      options,
      isLoaderOptions,
      params_for_fragmentation,
      isLoaderParamsForFragmentation,
      cohort_setup,
      show_filter,
    } = this.props;

    let { start_date, end_date } = cohort_setup;

    const main_options = {
      cohort_type: COHORT_TYPE_OPTIONS,
      trend_type: TREND_TYPE_OPTIONS,
      users: [],
      group_by: params_for_fragmentation,
      filter_by: params_for_fragmentation,
      apps: this.props.apps.map(i => ({ label: i.name, value: i.app_id })),
      // app_id: this.props.match.params.app_id
    };

    const tabs = [
      {
        label: "Params",
        tabKey: "params",
        options: options.params.map(i => i.value),
        // value: show_filter.v1th,
        isMulti: false,
      },
      {
        label: "Events",
        tabKey: "events",
        options: options.events.map(i => i.value),
        // value: null,
        isMulti: true,
      },
    ];

    const type_of_select = Array.isArray(show_filter.v1th)
      ? "events"
      : "params";

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Cohort Reports | Mobihunter" />

          <Container fluid>
            <DynamicFormMultipleFilter
              activePlug={true}
              plugText="Cohort Reports"
              onFiltersChange={this.onFiltersChange}
              onFilterSelect={this.onFilterSelect}
              style={{
                padding: "15px 0",
                background: "transparent",
              }}
              rowStyle={{
                padding: "0 0 0 0",
                top: 94,
                boxShadow:
                  "100px -25px 0px 0px #f8f8fb, -100px -25px 0px 0px #f8f8fb",
              }}
              selectedDate={[]}
              filtered_by={["report"]}
              dateFilters={[
                {
                  plug: "Date range",
                  key: "date_range",
                  isTitle: false,
                  value: { start_date, end_date },
                },
              ]}
            />

            <ReportingTemplates
              options={this.props.templates}
              value={this.props.template?.id}
              onChange={this.props.changeCohortReportTemplate}
              onSave={this.props.saveCohortReportTemplate}
              onCreate={this.props.createCohortReportTemplate}
              onDelete={this.props.deleteCohortReportTemplate}
            />

            {/* <DynamicFormMultipleFilter
              onFiltersChange={this.onFiltersChange}
              onFilterSelect={this.onFilterSelect}
              style={{ padding: 0 }}
              selectedDate={[]}
              filtered_by={["report"]}
              dateFilters={[
                {
                  plug: "Date range",
                  key: "date_range",
                  isTitle: false,
                  value: { start_date, end_date }
                }
              ]}
            /> */}
            <CohortReportsSettingPanel
              initialData={cohort_setup}
              options={main_options}
              onChange={this.onChangeCohortSetup}
            />
            <CardStyled>
              <CardBody>
                <div className="card-data-header">
                  <div className="d-flex align-items-center">
                    <span className="me-3">Show</span>
                    <CSelect
                      value={show_filter.v1th}
                      activeTab={type_of_select}
                      onChange={e => this.onChangeShowFilter(1, e)}
                      width="200px"
                      className="me-3"
                      tabs={tabs}
                    />
                    <Select
                      options={show_filter.o2th}
                      onChange={e => this.onChangeShowFilter(2, e)}
                      value={show_filter.v2th}
                      classNamePrefix="select2-selection"
                      className="cohort-report-select-filter me-3"
                      isLoading={isLoaderOptions}
                    />
                    <div className="form-check form-check-info me-3">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="per-user-checkbox"
                        disabled
                      />
                      <label
                        className="form-check-label cursor-default"
                        htmlFor="per-user-checkbox "
                      >
                        Per user
                      </label>
                    </div>
                    <div className="form-check form-check-info">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="real-time-cohort-checkbox"
                        // defaultChecked
                        disabled
                      />
                      <label
                        className="form-check-label cursor-default"
                        htmlFor="real-time-cohort-checkbox"
                      >
                        Real-time cohort
                      </label>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <Select
                      // value={selectedCashbacks}
                      options={DATE_OPTIONS}
                      onChange={e => this.onChangeDays(e)}
                      value={cohort_setup.days}
                      classNamePrefix="select2-selection"
                      className="select-date me-3"
                    />
                    <div className="btn-group me-3" role="group">
                      {TYPE_OF_VIEW_OPTIONS.map(i => (
                        <React.Fragment key={i.value}>
                          <input
                            type="radio"
                            className="btn-check"
                            name="type-of-visible-data"
                            id={`type-of-visible-data-${i.value}`}
                            autoComplete="off"
                            onChange={() => this.onChangeTypeOfView(i.value)}
                            checked={this.state.type_of_view === i.value}
                            disabled={i.disabled}
                          />
                          <label
                            className="btn btn-outline-primary mb-0"
                            htmlFor={`type-of-visible-data-${i.value}`}
                          >
                            <i
                              className={`${i.icon} me-1`}
                              style={{ verticalAlign: "middle" }}
                            />
                            {i.label}
                          </label>
                        </React.Fragment>
                      ))}
                    </div>
                    <div className="btn-group" role="group">
                      {DATA_FORMAT_OPTIONS.map(i => (
                        <React.Fragment key={i.value}>
                          <input
                            type="radio"
                            className="btn-check"
                            name="type-of-date-format"
                            id={`type-of-date-format-${i.value}`}
                            autoComplete="off"
                            onChange={() => this.onChangeType(i.value)}
                            checked={cohort_setup.type === i.value}
                            disabled={i.disabled}
                          />
                          <label
                            className="btn btn-outline-primary mb-0"
                            htmlFor={`type-of-date-format-${i.value}`}
                          >
                            <i
                              className={`${i.icon} me-1`}
                              style={{ verticalAlign: "middle" }}
                            />
                            {i.label}
                          </label>
                        </React.Fragment>
                      ))}
                    </div>
                    <Button
                      color="primary"
                      outline
                      // onClick={this.handleExport}
                      onClick={this.props.downloadCohortReportData}
                      className="ms-3"
                    >
                      <i className="bx bx-download" />
                    </Button>
                  </div>
                </div>
              </CardBody>
            </CardStyled>
            {this.state.type_of_view === TYPE_OF_VIEW_OPTIONS[0].value ? (
              <CohortReportsChartView />
            ) : (
              <CohortReportsTableView
                data={data}
                loading={loading}
                cohort_setup={cohort_setup}
                options={main_options}
                title={`Daily ${
                  Array.isArray(show_filter.v1th)
                    ? "`" + show_filter.v1th.map(i => i.label).join(", ") + "`"
                    : show_filter.v1th?.label
                } ${show_filter.v2th?.label}`}
                sub_title={
                  cohort_setup.type === "cumulative" ? "cumulative" : null
                }
                onChange={this.onChangeCohortSetup}
              />
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const CardStyled = styled(Card)`
  .card-data-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .square-switch {
    label {
      margin-bottom: 0;
      vertical-align: middle;
      width: 75px;

      //input[switch]:checked + label:after {
      //  //left: 56px;
      //}
    }
    input:checked + label:after {
      left: 52px;
    }
  }

  .show-select__multi {
    max-width: 120px;
  }

  .select-date {
    width: 105px !important;
  }

  .cohort-report-select-filter {
    z-index: 2;
    width: 150px;

    &.unique-select-width {
      width: 190px !important;
    }

    .dropdown-heading-value ~ svg {
      margin-top: 1px;
      margin-right: -2px;
    }

    .select2-selection__indicator-separator {
      display: none !important;
    }

  }
`;

CohortReports.propTypes = {
  data: PropTypes.any,
  options: PropTypes.object,
  loading: PropTypes.bool,
  isLoaderOptions: PropTypes.bool,
  getCohortReportList: PropTypes.func,
  getCohortReportOptions: PropTypes.func,
  getCohortReportParamsForFragmentation: PropTypes.func,
  params_for_fragmentation: PropTypes.array,
  isLoaderParamsForFragmentation: PropTypes.bool,
  show_filter: PropTypes.object,
  cohort_setup: PropTypes.any,
  initCohortReport: PropTypes.func,
  setCohortReportShowFilter: PropTypes.func,
  match: PropTypes.any,
  setCohortReportCohortSetup: PropTypes.func,
  patchCohortReportCohortSetup: PropTypes.func,
  apps: PropTypes.any,
  templates: PropTypes.array,
  template: PropTypes.any,
  downloadCohortReportData: PropTypes.func,
  changeCohortReportTemplate: PropTypes.func,
  saveCohortReportTemplate: PropTypes.func,
  createCohortReportTemplate: PropTypes.func,
  deleteCohortReportTemplate: PropTypes.func,
  setInitCohortReportState: PropTypes.func,
};

const mapStateToProps = state => ({
  data: state.CohortReportList.data,
  templates: state.CohortReportList.templates,
  template: state.CohortReportList.template,
  options: state.CohortReportList.options,
  params_for_fragmentation: state.CohortReportList.params_for_fragmentation,
  loading: state.CohortReportList.loading,
  isLoaderOptions: state.CohortReportList.isLoaderOptions,
  isLoaderParamsForFragmentation:
    state.CohortReportList.isLoaderParamsForFragmentation,
  show_filter: state.CohortReportList.show_filter,
  cohort_setup: state.CohortReportList.cohort_setup,
  apps: state.Apps.data.results,
});

export default connect(mapStateToProps, {
  getCohortReportList,
  getCohortReportOptions,
  getCohortReportParamsForFragmentation,
  initCohortReport,
  setCohortReportShowFilter,
  setCohortReportCohortSetup,
  patchCohortReportCohortSetup,
  downloadCohortReportData,
  changeCohortReportTemplate,
  saveCohortReportTemplate,
  deleteCohortReportTemplate,
  createCohortReportTemplate,
  setInitCohortReportState,
})(CohortReports);
